/*** CONSTANTS ***/

// SI SE CAMBIA EL CLASSPREFIX, ES NECESARIO CAMBIARLO TAMBIEN EN EL CONFIG.SCSS
// PREFERIBLEMENTE NO CAMBIAR LA CLASE
export const CLASSPREFIX = 'ctm-150'